import React from 'react';

const AboutHero = () => {
  return (
    <div className="text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side - Text Content */}
          <div data-aos="fade-left" >
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-black text-sm font-medium mb-6">
              <span className="w-2 h-2 bg-cyan-300 rounded-full mr-2"></span>
              ABOUT UNIQUE VISA SERVICES
            </div>
            <h1 className="text-4xl text-black md:text-5xl font-bold mb-6">
              Your Trusted Europe Countries Immigration Partner
            </h1>
            <p className="text-xl text-black leading-relaxed">
             We provide meticulous, dedicated support for your Europe Countries immigration journey. Your case isn't another file. It's our only focus. Your dream is our commitment, and we give it the undivided attention it deserves.
            </p>
          </div>

          {/* Right Side - Image */}
          <div className="flex justify-center" data-aos="fade-right">
            <div className="bg-blue-200/20 backdrop-blur-sm rounded-2xl p-8 border border-blue-200/20">
              <img 
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                alt="UK Immigration Services"
                className="rounded-xl w-full max-w-md shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutHero;